import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../../../theme';

export const useEstimatedTimeTooltipStyles = createStyles(({ token }) => ({
  quoteTooltipOverlay: {
    '.ant-tooltip-inner': {
      backgroundColor: `${token.colorWhite} !important`,
      boxShadow: `${hexToRgbaWithAlpha(ThemeColors.COLOR_GREY_BLUISH, 0.25)} 0 -1px 0 0, ${ThemeColors.COLOR_GREY8_1} 1px 1px 6px 0`,
      color: ThemeColors.COLOR_GREY3,
      fontWeight: 500,
      fontSize: ThemeFont.FONT_SIZE_XS,
      fontFamily: token.fontFamily,
      padding: token.paddingXS,

      '&::after': {
        borderTopColor: `${token.colorWhite} !important`,
      },
    },
  },
  quoteTooltipContent: {
    display: 'flex',
    alignItems: 'center',

    '.fas': {
      color: token.colorPrimary,
      fontSize: token.fontSizeLG,
      marginRight: ThemeSpaces.SPACE_NORM0_5,
    },
  },
}));
